import { ASSISTANT_PENDING_TEXT } from '@/constants/chat'

/**
 * @param {Record<string, unknown>} prev
 * @param {Record<string, unknown>} patch
 */
export function patchWebsiteCrmDemoMessage(prev, patch) {
  return {
    ...prev,
    text: '',
    ...patch,
  }
}

/**
 * @param {(
 *   updater: (prev: Record<string, unknown[]>) => Record<string, unknown[]>
 * ) => void} setMessagesByThreadId
 * @param {string} tid
 * @param {string} pendingId
 * @param {Record<string, unknown>} patch
 */
export function updatePendingWebsiteCrmDemoMessage(setMessagesByThreadId, tid, pendingId, patch) {
  setMessagesByThreadId((inner) => {
    const list = [...(inner[tid] ?? [])]
    const idx = list.findIndex((m) => m.id === pendingId)
    if (idx === -1) return inner
    const next = [...list]
    next[idx] = patchWebsiteCrmDemoMessage(list[idx], patch)
    return { ...inner, [tid]: next }
  })
}

/** @param {Record<string, unknown>} prev */
export function initialWebsiteCrmStreamPatch(prev) {
  return patchWebsiteCrmDemoMessage(prev, {
    text: ASSISTANT_PENDING_TEXT,
    demoStreamActive: true,
    thoughtSummary: 'Thinking…',
    thoughtDetails: [],
    blocks: [],
  })
}
